import { ReactNode } from 'react';
import Menu from '../Menu';
import * as Style from './style';
import { MenuItem } from 'menu/MenuItem';

interface DropdownMenuProps {
	menuItems: MenuItem[];
	children: ReactNode | string;
}

const DropdownMenu = ({ menuItems, children }: DropdownMenuProps) => {
	return (
		<Menu menuItems={menuItems} Style={Style}>
			{children}
		</Menu>
	);
};

export default DropdownMenu;
